import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WsgSharedModule }  from '@morningstar/wsg/shared';
import { SplashPageService } from './splash-page.service';
import { SplashPageComponent } from './splash-page.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    WsgSharedModule
  ],
  exports: [
    SplashPageComponent
  ],
  declarations: [
    SplashPageComponent
  ],
  providers: [
    SplashPageService
  ]
})
export class SplashPageModule { }
